// import Vue from 'vue'
import consts from "@/consts"
import {diffObjects, getApiProps, setFilterFields} from "@/lib/lib";

const changedField = 'changed_at';
const filterFields = ["leg_number", "customer_code", "driver_code", "container_number", "customer_work_order_reference", "chassis_number",];

export default {
    state: {
        trandataDmsLiteLoad: false,
        trandataDmsFullLoad: false,
        trandataDms: {},
        trandataDmsTimeAgo: {},
    },
    actions: {
        fetchTrandataDms/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchTrandataDms', args, time: Date.now() / 1000})

                const params = getApiProps('trandataDms', args)
                let data = {...args}
                //if (args?.lite) params.withAddress = data.withAddress = 0;
                if (!args?.force) params['filter[changed]'] = data['filter[changed]'] = getters.getTrandataDmsChangedTimeMax
                this.$api.trandataDms.getAll(args?.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTrandataDms', args, inprogress: false})
                    });
            })
        },
        fetchTrandataDmsAll({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchTrandataDmsAll', args: {}, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args: {}, time: Date.now() / 1000})

                const params = getApiProps('trandataDms', {})
                this.$api.trandataDms.getAll(null, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setTrandataDms', response.data)
                            commit('setTrandataDmsLiteLoad', true)
                            commit('setTrandataDmsFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchTrandataDmsAll', {})
                        }, 60 * 1000)
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTrandataDmsAll', args: {}, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args: {}, inprogress: false})
                    });
            })
        },
        fetchTrandataDmsAllPages({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }

                //dispatch('setLastCall', {name: 'fetchUnitsLmsgsAll', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args, time: Date.now() / 1000})

                let fetch = dispatch('fetchTrandataDms', {/*page, 'page-size': pageSize, force: true, */...args})
                    .then((data) => {
                        commit('setTrandataDms', data)
                    })
                    .catch(() => {
                        dispatch('fetchTrandataDms', {/*page, 'page-size': pageSize, force: true, */...args})
                    })

                resolve([fetch])
            })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setTrandataDmsLiteLoad', true)
                            commit('setTrandataDmsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchUnitsLmsgsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args, inprogress: false})
                })
        },

        fetchTrandataDmsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isTrandataDmsFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchTrandataDms', args)
                .then((data) => {
                    commit('updateTrandataDms', data)
                    // return dispatch('fetchTrandataDms', {fields: 'object_id',expand: '', force: true})
                })
                // .then((data) => {
                //     commit('filterTrandataDms', data)
                // })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchTrandataDmsChanged', args, inprogress: false})
                });
        },

        reloadTrandataDmsAll({commit, dispatch}, args) {
            commit('clearTrandataDms')
            return dispatch('fetchTrandataDmsAllLite', args)
                .then(() => {
                    dispatch('fetchTrandataDmsAllPages', args)
                })
        },
    },
    mutations: {
        setTrandataDmsLiteLoad(state, LiteLoad) {
            state.trandataDmsLiteLoad = state.trandataDmsLiteLoad || LiteLoad
        },
        setTrandataDmsFullLoad(state, FullLoad) {
            state.trandataDmsFullLoad = state.trandataDmsFullLoad || FullLoad
        },

        setTrandataDms(state, nTrandataDms) {
            state.trandataDms = nTrandataDms.reduce((tranDataDmsByIds, nTranDataDms) => {
                setFilterFields(nTranDataDms, filterFields)
                tranDataDmsByIds[nTranDataDms.id] = Object.freeze(nTranDataDms)
                return tranDataDmsByIds
            }, {})
        },

        updateTrandataDms(state, nTrandataDms) {
            if (!Object.keys(state.trandataDms).length) {
                state.trandataDms = nTrandataDms.reduce((tranDataDmsByIds, nTranDataDms) => {
                    setFilterFields(nTranDataDms, filterFields)
                    tranDataDmsByIds[nTranDataDms.id] = Object.freeze(nTranDataDms)
                    return tranDataDmsByIds
                }, {})
                return true
            }
            //console.log('updateTrandataDmss', Object.keys(state.trandataDms).length, nTrandataDms.length)
            nTrandataDms.forEach((nTranDataDms) => {
                setFilterFields(nTranDataDms, filterFields)

                let object_id = nTranDataDms.id
                let trandataDms = state.trandataDms[object_id]
                if (!trandataDms) {
                    state.trandataDms[object_id] = Object.freeze(nTranDataDms)
                } else
                if (!state.trandataDmsFullLoad || trandataDms[changedField] < nTranDataDms[changedField]) {
                    // updateObjectByDiff(state.trandataDms[object_id], nTranDataDms)
                    // delete nTranDataDms.object_id
                    let newTrandataDms = diffObjects(trandataDms, nTranDataDms) || {}
                    state.trandataDms[object_id] = Object.freeze({...trandataDms, ...newTrandataDms})
                }
            })
        },
        filterTrandataDms(state, nTrandataDms) {
            let nIds = nTrandataDms.map(l => l.id)
            let removedIds = Object.keys(state.trandataDms).filter(id => !nIds.find(nId => nId == id))
            removedIds.forEach(removedId => {
                delete state.trandataDms[removedId]
            })
        },
        updateUnitTrandataDms(state, nTranDataDms) {
            if (!nTranDataDms) return;
            setFilterFields(nTranDataDms, filterFields)

            let object_id = nTranDataDms.id
            let trandataDms = state.trandataDms[object_id]
            if (!trandataDms) {
                state.trandataDms[object_id] = Object.freeze(nTranDataDms)
            } else
            if (!state.trandataDmsFullLoad || trandataDms[changedField] < nTranDataDms[changedField]) {
                // updateObjectByDiff(state.trandataDms[object_id], nTranDataDms)
                // delete nTranDataDms.object_id
                let newTrandataDms = diffObjects(trandataDms, nTranDataDms) || {}
                state.trandataDms[object_id] = Object.freeze({...trandataDms, ...newTrandataDms})
            }
        },

        clearTrandataDms(state, {unitId} = {}) {
            if (unitId) {
                delete state.trandataDms[unitId]
                delete state.trandataDmsTimeAgo[unitId]
            } else {
                state.trandataDms = {}
                state.trandataDmsTimeAgo = {}
                state.trandataDmsLiteLoad = false
                state.trandataDmsFullLoad = false
            }
        },
    },
    getters: {
        isTrandataDmsLiteLoad(state) {
            return state.trandataDmsLiteLoad
        },
        isTrandataDmsFullLoad(state) {
            return state.trandataDmsFullLoad
        },
        getTrandataDms(state) {
            return Object.values(state.trandataDms)
        },
        getTrandataDmsIds(state) {
            return Object.keys(state.trandataDms)
        },
        getUnitsIdsIsTrandataDmsFullLoad(state) {
            return Object.values(state.trandataDms)
                .filter(trandataDms => (typeof trandataDms[changedField] !== 'undefined'))//!!!???
                .map(trandataDms => trandataDms.object_id)
        },
        getTrandataDmsChangedTimeMax(state) {
            return Object.values(state.trandataDms)
                .map(dms => dms[changedField])
                .filter(t => !!t)
                .reduce((a, b) => (a > b ? a : b))
        },
        getTrandataDmsByIds(state) {
            return state.trandataDms
        },

        getTrandataDmsTimeAgoByIds(state) {
            return state.trandataDmsTimeAgo
        },

        getTrandataDmsByDriverCode(state) {
            return Object.values(state.trandataDms)
                .filter(trandataDms => trandataDms?.driver_code)
                .reduce((dataByIds, trandataDms) => {
                    if (!dataByIds[trandataDms.driver_code]) dataByIds[trandataDms.driver_code] = []
                    dataByIds[trandataDms.driver_code].push(trandataDms)
                    return dataByIds
                }, {})
        },
    }
}
